import React from 'react';
import { deriveRiggingPipelineStages } from '../../features/riggingJobStatus';

export default function RiggingPipelineProgress({
  operation,
  jobStatus,
  attemptStatus,
  hasArtifacts = false,
  hasResult = false,
  workerRuntimeEnabled,
}) {
  const stages = deriveRiggingPipelineStages({
    operation,
    jobStatus,
    attemptStatus,
    hasArtifacts,
    hasResult,
    workerRuntimeEnabled,
  });

  return (
    <ol className="list-unstyled mb-0" data-testid="rigging-pipeline-progress">
      {stages.map((stage, index) => (
        <li key={stage.id} className="d-flex align-items-start gap-2 mb-2">
          <span className="text-muted" aria-hidden="true">
            {index === 0 ? '●' : '↓'}
          </span>
          <div>
            <div className="fw-semibold">{stage.label}</div>
            <div className="small text-muted text-capitalize">
              {String(stage.state).replace(/_/g, ' ')}
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
}
